export class CashFlowToken {
  static ICashFlowRepository = Symbol("ICashFlowRepository");
  static CashFlowUseCase = Symbol("CashFlowUseCase");
  static CashFlowViewModel = Symbol("CashFlowViewModel");
}
